import React from 'react';

import PropTypes from 'prop-types';

import TableQrCodes from '../components/TableQrCodes';
import Discounts from '../components/Discounts';

function Settings({ branch }) {
  return (
    <div className="flex flex-col flex-1 p-3 lg:px-10 lg:p-5 overflow-y-auto overflow-x-hidden">
      <div className="grid grid-cols-10 gap-3">
        <div className="card col-span-10 lg:col-span-8 xl:col-span-6">
          <TableQrCodes branch_uuid={branch} />
        </div>

        <div className="card col-span-10 lg:col-span-8 xl:col-span-6">
          <Discounts />
        </div>
      </div>
    </div>
  );
}

Settings.defaultProps = {
  branch: {},
};

Settings.propTypes = {
  branch: PropTypes.instanceOf(Object),
};

export default Settings;
